
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {TickGetFilterResponse} from './TickGetFilterResponse';

/**
 * TickGetFilterRequest struct
 */
class TickGetFilterRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Set=} symbolIds
   * @param {!Set=} symbolNames
   * @constructor
   */
  constructor (parent = new Request(), symbolIds = new Set(), symbolNames = new Set()) {
    super()
    super.copy(parent)
    this.SymbolIds = symbolIds
    this.SymbolNames = symbolNames
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TickGetFilterRequest}
   * @param {!TickGetFilterRequest} other Other struct
   * @returns {!TickGetFilterRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SymbolIds != null) {
      this.SymbolIds = new Set()
      for (let item of other.SymbolIds) {
        if (item != null) {
          let tempItem
          tempItem = new UUID(item)
          this.SymbolIds.add(tempItem)
        } else {
          this.SymbolIds.add(null)
        }
      }
    } else {
      this.SymbolIds = null
    }
    if (other.SymbolNames != null) {
      this.SymbolNames = new Set()
      for (let item of other.SymbolNames) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.SymbolNames.add(tempItem)
        } else {
          this.SymbolNames.add(null)
        }
      }
    } else {
      this.SymbolNames = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TickGetFilterRequest}
   * @returns {!TickGetFilterRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TickGetFilterRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TickGetFilterRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TickGetFilterRequest}
   * @param {!TickGetFilterRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TickGetFilterRequest)) {
      throw new TypeError('Instance of TickGetFilterRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TickGetFilterRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SymbolIds: ((this.SymbolIds != null) ? Array.from(this.SymbolIds, item => ((item != null) ? item.toString() : null)) : null),
      SymbolNames: ((this.SymbolNames != null) ? Array.from(this.SymbolNames, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TickGetFilterRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TickGetFilterRequest} other Object value
   * @returns {!TickGetFilterRequest} Created struct
   */
  static fromObject (other) {
    return new TickGetFilterRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TickGetFilterRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TickGetFilterRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TickGetFilterRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 2026
  }
}

export { TickGetFilterRequest };

/**
 * Fast Binary Encoding TickGetFilterRequest field model
 */
class FieldModelTickGetFilterRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.SymbolIds = new fbe.FieldModelSet(new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.SymbolNames = new fbe.FieldModelSet(new fbe.FieldModelString(buffer, this.SymbolIds.fbeOffset + this.SymbolIds.fbeSize), buffer, this.SymbolIds.fbeOffset + this.SymbolIds.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelTickGetFilterRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelTickGetFilterRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTickGetFilterRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SymbolIds.fbeSize + this.SymbolNames.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTickGetFilterRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SymbolIds.fbeExtra + this.SymbolNames.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTickGetFilterRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTickGetFilterRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTickGetFilterRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 2026
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTickGetFilterRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTickGetFilterRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolIds.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolIds.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolIds.fbeSize

    if ((fbeCurrentSize + this.SymbolNames.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolNames.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolNames.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTickGetFilterRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTickGetFilterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTickGetFilterRequest}
   * @param {!TickGetFilterRequest} fbeValue Default value, defaults is new TickGetFilterRequest()
   * @returns {!TickGetFilterRequest} TickGetFilterRequest value
   */
  get (fbeValue = new TickGetFilterRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTickGetFilterRequest}
   * @param {!TickGetFilterRequest} fbeValue TickGetFilterRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolIds.fbeSize) <= fbeStructSize) {
      this.SymbolIds.get(fbeValue.SymbolIds)
    } else {
      fbeValue.SymbolIds.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolIds.fbeSize

    if ((fbeCurrentSize + this.SymbolNames.fbeSize) <= fbeStructSize) {
      this.SymbolNames.get(fbeValue.SymbolNames)
    } else {
      fbeValue.SymbolNames.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolNames.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTickGetFilterRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTickGetFilterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTickGetFilterRequest}
   * @param {!TickGetFilterRequest} fbeValue TickGetFilterRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTickGetFilterRequest}
   * @param {TickGetFilterRequest} fbeValue TickGetFilterRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SymbolIds.set(fbeValue.SymbolIds)
    this.SymbolNames.set(fbeValue.SymbolNames)
  }
}

export { FieldModelTickGetFilterRequest };

/**
 * Fast Binary Encoding TickGetFilterRequest model
 */
class TickGetFilterRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTickGetFilterRequest(this.buffer, 4)
  }

  /**
   * Get the TickGetFilterRequest model
   * @this {!TickGetFilterRequestModel}
   * @returns {!FieldModelTickGetFilterRequest} model TickGetFilterRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TickGetFilterRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TickGetFilterRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TickGetFilterRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TickGetFilterRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTickGetFilterRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TickGetFilterRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TickGetFilterRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TickGetFilterRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TickGetFilterRequestModel}
   * @param {!TickGetFilterRequest} value TickGetFilterRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TickGetFilterRequestModel}
   * @param {!TickGetFilterRequest} value TickGetFilterRequest value, defaults is new TickGetFilterRequest()
   * @return {!object} Deserialized TickGetFilterRequest value and its size
   */
  deserialize (value = new TickGetFilterRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TickGetFilterRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TickGetFilterRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TickGetFilterRequestModel}
   * @param {!number} prev Previous TickGetFilterRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TickGetFilterRequestModel };
TickGetFilterRequest.__has_response = true;
TickGetFilterRequest.__response_class = TickGetFilterResponse;
